module.exports = __webpack_public_path__ + "static/cosmicguard.com/img/rushnation.54acbf18.png";